import { createVanIconComponent } from "./van"

const BrushOutlined = createVanIconComponent("brush-o")
export default BrushOutlined
